// Projected win % rendered as a whole number.
export const formatWinPercent = (fraction: number) =>
  `${Math.round(fraction * 100)}%`;
